import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
const visualItems = ['Step-by-step movement sequences', 'Start and end positions', 'Directional arrows', 'Working-side indicators', 'Foot-position diagrams', 'Leg-direction guides', 'Pelvic-alignment visuals', 'Muscle-focus graphics', 'Class timelines', 'Equipment placement', 'Correct-vs-incorrect comparisons', 'Easier / Standard / Level Up options', 'Pulse and hold guides', 'Beginner-to-advanced progressions', 'Instructor cues', 'Transition guides', 'Ready-to-teach class structures'];
export function WhyDifferent() {
  return <section className="bg-inverse px-4 py-20 text-inverse-foreground sm:py-28" data-id="element-397" data-mp="i0x9ap6iab7n">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-398" data-mp="2xsbf2toqnqj6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-399" data-mp="32sz3r8phvva8">
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-accent-soft" data-id="element-400" data-mp="3gpxzyq4004t9">
            <EyeIcon size={16} strokeWidth={1.5} className="text-accent" aria-hidden="true" data-id="element-401" data-mp="3uq8rlvd4tnfh" />
            100% visual core teaching material
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-inverse-foreground sm:text-4xl" data-id="element-402" data-mp="7jpx66dygiqv">
            One of the Biggest Differences Between Barre Instructor Ready and{' '}
            <span className="italic text-accent-soft" data-id="element-403" data-mp="h9ri4pb0hl1k">Traditional Fitness Manuals</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-404" data-mp="cay5t07go02z" />
          <p className="mt-5 text-base leading-7 text-inverse-foreground/75" data-id="element-405" data-mp="cb7yivjw4lcd">
            The six-volume core system was designed to help you see the class,
            not fight through pages of theory.
          </p>
          <FlowLine tone="dark" className="mt-6" steps={['See the Position', 'See the Movement', 'See the Progression', 'Teach With Confidence']} data-id="element-406" data-mp="m6rfmbtspfh2" />
          <p className="mt-8 font-display text-3xl font-semibold leading-tight text-inverse-foreground" data-id="element-407" data-mp="1396xg8yla2j6">
            See it. <span className="italic text-accent-soft" data-id="element-408" data-mp="182jcbrdguuyq">Understand it.</span>{' '}
            Teach it.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-accent/40 bg-inverse-raised p-6 shadow-elevated sm:p-9" data-id="element-409" data-mp="1h1mvswgjpcdr">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent-soft" data-id="element-410" data-mp="3nsw0t9o3ark3">
            Throughout the 100% visual core system you will find:
          </p>
          <ul className="mt-6 grid gap-x-6 sm:grid-cols-2" data-id="element-411" data-mp="3l7eloh3par2e">
            {visualItems.map(item => <li key={item} className="flex items-center gap-2.5 border-b border-inverse-foreground/10 py-3 text-sm font-medium text-inverse-foreground" data-id="element-412" data-mp="3gh7y8kkxdclq">
                <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-accent" aria-hidden="true" data-id="element-413" data-mp="36jacq4ug9twt" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}